import { ClassProperties } from '../types/utils'

export type ContributorWithRole = {
  name: string
  role: string
}

export type TitleMetadataType = ClassProperties<TitleMetadata>

export default class TitleMetadata {
  arrangers: string[]
  artists: string[]
  composers: string[]
  contributors: string[]
  contributors_with_roles: ContributorWithRole[]
  description: string | null
  difficulty_level: number | null
  duration: number | null
  exercise_format: string[]
  format: string | null
  genres: string[]
  grade_levels: []
  cover_art_url: string | null
  cover_art_directive: string | null
  instruments: string[]
  lyricists: string[]
  opening_key: string | null
  primary_contributor: string | null
  publisher: string | null
  simplified_voicings: string[]
  title: string
  usergen: boolean
  voicing: string | null
  seller_avatar_id: string | null
  audio_preview_path: string | null
  audio_reference_path: string | null

  constructor(props: TitleMetadata) {
    this.arrangers = props?.arrangers || []
    this.artists = props?.artists || []
    this.composers = props?.composers || []
    this.contributors = props?.contributors || []
    this.contributors_with_roles = props?.contributors_with_roles || []
    this.description = props?.description ?? null
    this.difficulty_level = props?.difficulty_level
    this.duration = props?.duration
    this.exercise_format = props?.exercise_format || []
    this.format = props?.format
    this.genres = props?.genres || []
    this.grade_levels = props?.grade_levels || []
    this.cover_art_url = props?.cover_art_url
    this.cover_art_directive = props?.cover_art_directive
    this.instruments = props?.instruments || []
    this.lyricists = props?.lyricists || []
    this.opening_key = props?.opening_key
    this.primary_contributor = props?.primary_contributor
    this.publisher = props?.publisher
    this.simplified_voicings = props?.simplified_voicings || []
    this.title = props?.title
    this.usergen = !!props?.usergen
    this.voicing = props?.voicing
    this.seller_avatar_id = props?.seller_avatar_id
    this.audio_preview_path = props?.audio_preview_path
    this.audio_reference_path = props?.audio_reference_path
  }
}
